import * as actions from "../action.constants";

const requestDataExplorerTemplates = (data, callback) => ({
  type: actions.REQUEST_DATA_EXPLORER_TEMPLATES,
  payload: data,
  callback,
});

const storeDataExplorerTemplates = (data) => ({
  type: actions.STORE_DATA_EXPLORER_TEMPLATES,
  payload: data,
});

const requestDataExplorerAnalysis = (data) => ({
  type: actions.REQUEST_DATA_EXPLORER_ANALYSIS,
  payload: data,
});

const storeDataExplorerAnalysis = (data) => ({
  type: actions.STORE_DATA_EXPLORER_ANALYSIS,
  payload: data,
});

const storeDataExplorerSensorAnalysis = (data) => ({
  type: actions.STORE_DATA_EXPLORER_SENSOR_ANALYSIS,
  payload: data,
});

const requestDataExplorerTimezones = (data, callback) => ({
  type: actions.REQUEST_DATA_EXPLORER_TIMEZONES,
  payload: data,
  callback,
});

const storeDataExplorerTimezones = (data) => ({
  type: actions.STORE_DATA_EXPLORER_TIMEZONES,
  payload: data,
});

const saveDataExplorerSnapshot = (data, callback) => ({
  type: actions.SAVE_DATA_EXPLORER_SNAPSHOT,
  payload: data,
  callback,
});

const requestDataExplorerSnapshot = (callback) => ({
  type: actions.REQUEST_DATA_EXPLORER_SNAPSHOT,
  callback,
});

const storeDataExplorerSnapshot = (data) => ({
  type: actions.STORE_DATA_EXPLORER_SNAPSHOT,
  payload: data,
});

export {
  requestDataExplorerTemplates,
  storeDataExplorerTemplates,
  requestDataExplorerAnalysis,
  storeDataExplorerAnalysis,
  storeDataExplorerSensorAnalysis,
  requestDataExplorerTimezones,
  storeDataExplorerTimezones,
  saveDataExplorerSnapshot,
  requestDataExplorerSnapshot,
  storeDataExplorerSnapshot,
};
